import { useQuery, useMutation, useQueryClient } from 'react-query';
import { api } from './useAuth';

export interface PortalNotification {
  id: string;
  ticketId: string;
  type: string;
  title: string;
  message: string;
  readAtUtc: string | null;
  createdAtUtc: string;
}

export interface NotificationsResponse {
  items: PortalNotification[];
  unreadCount: number;
}

const NOTIFICATIONS_KEY = 'notifications';

export function useNotifications(enabled: boolean) {
  return useQuery(
    [NOTIFICATIONS_KEY],
    async () => {
      const { data } = await api.get<NotificationsResponse>('/notifications', {
        params: { limit: 30 },
      });
      return data;
    },
    {
      enabled,
      refetchInterval: 45_000,
      refetchOnWindowFocus: true,
    }
  );
}

export function useMarkNotificationRead() {
  const queryClient = useQueryClient();
  return useMutation(
    async (id: string) => {
      await api.patch(`/notifications/${id}/read`);
    },
    {
      onSuccess: () => queryClient.invalidateQueries([NOTIFICATIONS_KEY]),
    }
  );
}

export function useMarkAllNotificationsRead() {
  const queryClient = useQueryClient();
  return useMutation(
    async () => {
      await api.post('/notifications/read-all');
    },
    {
      onSuccess: () => queryClient.invalidateQueries([NOTIFICATIONS_KEY]),
    }
  );
}

export function useMarkTicketNotificationsRead() {
  const queryClient = useQueryClient();
  return useMutation(
    async (ticketId: string) => {
      await api.post(`/notifications/tickets/${ticketId}/read`);
    },
    {
      onSuccess: () => queryClient.invalidateQueries([NOTIFICATIONS_KEY]),
    }
  );
}
